/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "Munisita Prỹg-kurã-kar",
          "chinese": "Sĩnẽj Prỹg-kurã-kar",
          "coptic": "Komtike Prỹg-kurã-kar",
          "dangi": "Nági Prỹg-kurã-kar",
          "ethiopic": "Etijópi Prỹg-kurã-kar",
          "ethiopic-amete-alem": "Amete Alem Etijópi Prỹg-kurã-kar",
          "gregorian": "Papa Gregorju Prỹg-kurã-kar",
          "hebrew": "Emrajko Prỹg-kurã-kar",
          "indian": "Ĩnija Prỹg-kurã-kar pẽ",
          "islamic": "Isirỹ Prỹg-kurã-kar",
          "islamic-civil": "Isirỹ Prỹg-kurã-kar Siviv",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "Isirỹ Prỹg-kurã-kar (Umm al-Qura)",
          "iso8601": "Prỹg-kurã-kar ISO-8601",
          "japanese": "Japonẽj Prỹg-kurã-kar",
          "persian": "Pérsa Prỹg-kurã-kar",
          "roc": "Sĩnỹ Kar-mỹ Prỹg-kurã-kar"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "Ỹnoha Kufy-sĩ",
          "AED": "Ẽmĩrano Arame Jãnkamu",
          "AFA": "Afeganĩ (1927–2002)",
          "AFN": "Afeganĩ afegỹv",
          "ALK": "Arámánja Rég (1946–1965)",
          "ALL": "Arámánja Rég",
          "AMD": "Arámẽnja Daram",
          "ANG": "Ỹtiria Orỹnesa Kafejsĩ",
          "AOA": "Ỹgora Kwanza",
          "AOK": "Ỹgora Cuanza (1977–1990)",
          "AON": "Ỹgora cuanza tãg (1990–2000)",
          "AOR": "Ỹgora cuanza ki hynhan ka nĩ (1990–2000)",
          "ARA": "Arjẽtinỹ Asufraw",
          "ARL": "Arjẽtinỹ Kufy Rej (1970–1983)",
          "ARM": "Arjẽtinỹ Kufy (1881–1970)",
          "ARP": "Arjẽtinỹ Kufy (1983–1985)",
          "ARS": "Arjẽtinỹ Kufy // Arjẽntĩnỹ Kufy",
          "ATS": "Agtirija Serĩm",
          "AUD": "Awotyraria Nórar Si",
          "AWG": "Aruma Kafejsĩ",
          "AZM": "Ajermajjáv Manati (1993–2006)",
          "AZN": "Manati aseri",
          "BAD": "Mósinĩja-Hersegovĩna Ninỹ (1992–1994)",
          "BAM": "Mósinĩja Hersegovĩna-mré Mỹrko ta ũn há",
          "BAN": "Mósinĩja-Hersegovĩna Ninỹ Tãg (1994–1997)",
          "BBD": "Juvã-mág Nórar",
          "BDT": "Mágranési Taka",
          "BEC": "Mérjika Vĩpir (conv)",
          "BEF": "Mérjika Vĩpir",
          "BEL": "Mérjika Vĩpir (financ)",
          "BGL": "Mugarja Rev Tar",
          "BGM": "Mugarja Ver kynkar",
          "BGN": "Mugarja Rev",
          "BGO": "Mugarja Rev (1879–1952)",
          "BHD": "Marẽnh Ninỹ",
          "BIF": "Murũni Vĩpir",
          "BMD": "Karsa-ror-ag Nórar",
          "BND": "Mrunẽj Nórar",
          "BOB": "Morivija Jãnkamu",
          "BOL": "Morivijanũ (1863–1963)",
          "BOP": "Morivija Kufy",
          "BOV": "Morivija Munór",
          "BRB": "Mrasir Krujeru Tãg (1967–1986)",
          "BRC": "Mrasir Krusanu (1986–1989)",
          "BRE": "Mrasir Krujeru (1990–1993)",
          "BRL": "Mrasir Rejar",
          "BRN": "Mrasir Krusanu Tãg (1989–1990)",
          "BRR": "Mrasir Krujeru (1993–1994)",
          "BRZ": "Mrasir Krujeru (1942–1967)",
          "BSD": "Mahamỹ Nórar",
          "BTN": "Butỹ Guturũm",
          "BUK": "Mirmỹnja Kyate",
          "BWP": "Monsuvỹnỹ Pura",
          "BYB": "Miero-Husija Humro Tãg (1994–1999)",
          "BYN": "Miero-Husija Humro",
          "BYR": "Miero-Husija Humro (2000–2016)",
          "BZD": "Merise Nórar",
          "CAD": "Kanỹna Nórar",
          "CDF": "Kãgu Vĩpir",
          "CHE": "WIR Evoro",
          "CHF": "Suvisa Vĩpir",
          "CHW": "WIR Vĩpir",
          "CLE": "Sire Vẽjuven",
          "CLF": "Sirenũ ag vẽnhkãmur ũ",
          "CLP": "Sire Kufy",
          "CNH": "Sĩnỹ Yvỹn (offshore)",
          "CNX": "Nórar vẽnhkar mỹ máko mĩ Sĩnỹ tá",
          "CNY": "Sĩnỹ Yvỹn",
          "COP": "Kolãmja Kufy",
          "COU": "Vẽnhkãmun ũ kaja uri",
          "CRC": "Kotahika Korãn",
          "CSD": "Sérvija Ninỹ (2002–2006)",
          "CSK": "Sékorovaka Rãgre Tar",
          "CUC": "Kuma Kufy conv",
          "CUP": "Kuma Kufy",
          "CVE": "Pu-Tánh Vẽjuven",
          "CYP": "Sipre Rimra",
          "CZK": "Séka Rãgre",
          "DDM": "Aremỹja Rãjur tá Jãnkamu",
          "DEM": "Aremỹnhỹ Mỹrko",
          "DJF": "Nhimuti Vĩpir",
          "DKK": "Ninỹmỹrka Rãgre",
          "DOP": "Nomĩnĩka Kufy",
          "DZD": "Argerija Ninỹ",
          "ECS": "Ekuvanor Sukri",
          "ECV": "Ekuvanor UVC",
          "EEK": "Enhtonĩja Rãgre",
          "EGP": "Ejimto Rimra",
          "ERN": "Eriteréja Nagfa",
          "ESA": "Esipỹnja Kufy-sĩ (kãtá A)",
          "ESB": "Esipỹnja Kufy-sĩ (kãtá conv)",
          "ESP": "Esipỹnja Kufy-sĩ",
          "ETB": "Etiópija Mir",
          "EUR": "Evoro",
          "FIM": "Fĩrỹnija Mỹrka",
          "FJD": "Fiji Nórar",
          "FKP": "Mỹrvinỹ Rimra",
          "FRF": "Frỹsa Vĩpir",
          "GBP": "Rimra Eterĩnỹ",
          "GEK": "Jiórja Kupãni Rari",
          "GEL": "Jiórja Rari",
          "GHC": "Gỹnỹ Senhi (1979–2007)",
          "GHS": "Gỹnỹ Senhi",
          "GIP": "Nhimratar Rimra",
          "GMD": "Gỹmija Narasi",
          "GNF": "Ginẽ Vĩpir",
          "GNS": "Ginẽ Syri",
          "GQE": "Ginẽ Ekuvanor Ekuvele",
          "GRD": "Grésija Narakymỹ",
          "GTQ": "Guvỹtemỹra Kensav",
          "GWE": "Fóg tỹ Ginẽ Vẽjuven",
          "GWP": "Ginẽ-Misav Kufy",
          "GYD": "Gijỹnỹ Nórar",
          "HKD": "Hãg-Kãg Nórar",
          "HNL": "Ãnura Rẽpirá",
          "HRD": "Krovasija Ninỹ",
          "HRK": "Krovasija Kuna",
          "HTG": "Ajti Runja",
          "HUF": "Ũgrija Kafejsĩ",
          "IDR": "Ĩnonẽsija Rupija",
          "IEP": "Irỹna Rimra",
          "ILP": "Isihaé Rimra",
          "ILR": "Isihaé Sekév Si",
          "ILS": "Isihaé Sekév Tãg",
          "INR": "Ĩnija Rupija",
          "IQD": "Iraki Ninỹ",
          "IRR": "Irỹ Hi’av",
          "ISJ": "Kukryr-ga Rãgre Si",
          "ISK": "Kukryr-ga Rãgre",
          "ITL": "Itarija Rira",
          "JMD": "Jamỹjka Nórar",
          "JOD": "Jornánĩja Ninỹ",
          "JPY": "Japã Jenẽ",
          "KES": "Kẽnja Serĩm",
          "KGS": "Kirgi-Ga Kyr",
          "KHR": "Kỹmósa Hijév",
          "KMF": "Komor Vĩpir",
          "KPW": "Nãrti-Koréja Vãn",
          "KRH": "Koréja Sur Huvỹ (1953–1962)",
          "KRO": "Koréja Sur Vãn (1945–1953)",
          "KRW": "Koréja Sur Vãn",
          "KWD": "Kuvajti Ninỹ",
          "KYD": "Kanhmỹ Vãsogso Nórar",
          "KZT": "Kajakinhtỹv Tẽge",
          "LAK": "Ravusi Kim",
          "LBP": "Rimanũ Rimra",
          "LKR": "Sirijỹká Rupija",
          "LRD": "Rimérijỹ Nórar",
          "LSL": "Resotu Roti",
          "LTL": "Rituvỹnja Ritasi",
          "LTT": "Rituvỹnja Taronỹ",
          "LUC": "Rusẽmurgo Vĩpir conv.",
          "LUF": "Rusẽmurgo Vĩpir",
          "LUL": "Rusẽmurgo Vĩpir Jãnkamu",
          "LVL": "Rativija Rati",
          "LVR": "Rativija Humro",
          "LYD": "Rimija Ninỹ",
          "MAD": "Ar-Magrim Nirham",
          "MAF": "Ar-Magrim Vĩpir",
          "MCF": "Mõnỹku Vĩpir",
          "MDC": "Mãrnova Kopã",
          "MDL": "Mãrnova Revu",
          "MGA": "Mỹna-Gasikar Ari-ary",
          "MGF": "Mỹna-Gasikar Vĩpir",
          "MKD": "Mỹsenonĩja Ninỹ",
          "MKN": "Mỹsenonĩja Ninỹ (1992–1993)",
          "MLF": "Mỹri Vĩpir",
          "MMK": "Mijẽn-Mỹ Kijate",
          "MNT": "Mãgórija Tugrig",
          "MOP": "Mỹkav Pataka",
          "MRO": "Mũritỹni Ov-Gija (1973–2017)",
          "MRU": "Mũritỹni Ov-Gija",
          "MTL": "Mỹrta Rirá",
          "MTP": "Mỹrta Rimra",
          "MUR": "Mãriso Rupija",
          "MVP": "MVP",
          "MVR": "Mỹrniva Rupija",
          "MWK": "Mỹravi Kuvasa",
          "MXN": "Mẽsiku Kufy",
          "MXP": "Mẽsiku Kufy Kupri (1861–1992)",
          "MXV": "Mẽsiku Pir Rãg (UDI)",
          "MYR": "Mỹraja Rĩggin",
          "MZE": "Mãsỹmiki Vẽjuven",
          "MZM": "Mãsỹmiki Mẽtikar (1980–2006)",
          "MZN": "Mãsỹmiki Mẽtikar",
          "NAD": "Nỹmĩmija Nórar",
          "NGN": "Nĩjérija Nỹjra",
          "NIC": "Nĩkaraguva Kórnoma (1988–1991)",
          "NIO": "Nĩkaraguva Kórnoma",
          "NLG": "Orỹna Kafejsĩ",
          "NOK": "Nãrovéga Rãgre",
          "NPR": "Nẽpar Rupija",
          "NZD": "Zirỹnija Tãg Nórar",
          "OMR": "Omỹ Hijar",
          "PAB": "Panỹmỹ Mavo-Mova",
          "PEI": "Peru Ĩnti",
          "PEN": "Peru Rã Tãg",
          "PES": "Peru Rã (1863–1965)",
          "PGK": "Papuva Kinỹ",
          "PHP": "Firipinỹ Kufy",
          "PKR": "Pakinhtỹv Rupiya",
          "PLN": "Poronĩja Rẽrĩr",
          "PLZ": "Poronĩja Rẽrĩr (1950–1995)",
          "PTE": "Purutuga Vẽjuven",
          "PYG": "Paraguvaj Garnĩ",
          "QAR": "Katar Hijar",
          "RHD": "Ronésija Nórar",
          "ROL": "Romẽnija Rev (1952–2006)",
          "RON": "Romẽnija Rev",
          "RSD": "Séruvija Ninỹ",
          "RUB": "Husija Humro",
          "RUR": "Husija Humro (1991–1998)",
          "RWF": "Huvỹna Vĩpir",
          "SAR": "Aramija Savnita Hijar",
          "SBD": "Saromỹ Vẽsogso Nórar",
          "SCR": "Sejséri Rupija",
          "SDD": "Suná Ninỹ (1992–2007)",
          "SDG": "Suná Rimbra",
          "SDP": "Suná Rimbra (1957–1998)",
          "SEK": "Suvésija Rãgre",
          "SGD": "Sĩgapur Nórar",
          "SHP": "Sỹta Herenỹ Rimra",
          "SIT": "Enhrovenĩja Torar Há",
          "SKK": "Enhrovakija Rãgre",
          "SLL": "Krĩ Mĩgkusũg-fi Re’onĩ",
          "SOS": "Somỹrija Serĩm",
          "SRD": "Surinỹm Nórar",
          "SRG": "Surinỹm Kafejsĩ",
          "SSP": "Suná-Sur Rimra",
          "STD": "Sỹtomẽ Prĩsipi-mré Nómra (1977–2017)",
          "STN": "Sỹtomẽ Prĩsipi-mré Nómra",
          "SUR": "Sovijéti Humro",
          "SVC": "Er Sarvanor Korãn",
          "SYP": "Sirija Rimra",
          "SZL": "Suvasi-Ga Rirỹgenĩ",
          "THB": "Taj-Ga Mati",
          "TJR": "Tanijikinhtỹv Humro",
          "TJS": "Tanijikinhtỹv Somãnĩ",
          "TMM": "Turkomẽnisitỹ Manati (1993–2009)",
          "TMT": "Tukomẽnũ Manati",
          "TND": "Tunĩsija Ninỹ",
          "TOP": "Tãga Pa’ỹga",
          "TPE": "Timor Vẽjuven",
          "TRL": "Turkija Rira (1922–2005)",
          "TRY": "Turkija Rira",
          "TTD": "Tirinĩna Tomago-mré Nórar",
          "TWD": "Tajvỹ Nórar Tãg",
          "TZS": "Tỹnjỹnĩja Serĩm",
          "UAH": "Ukrỹnĩja Hyryvinja",
          "UAK": "Ukrỹnĩja Karbovanẽ",
          "UGS": "Ugỹna Serĩm (1966–1987)",
          "UGX": "Ugỹna Serĩm",
          "USD": "Nãrti-Amẽrikỹ Nórar",
          "USN": "Nãrti-Amẽrikỹ Nórar (kurã ũ kã)",
          "USS": "Nãrti-Amẽrikỹ Nórar (kurã hã)",
          "UYI": "Uruguvaj Kufy vẽkãmur ũ",
          "UYP": "Uruguvaj Kufy (1975–1993)",
          "UYU": "Uruguvaj Kufy",
          "UYW": "UYW",
          "UZS": "Unhmekinhtỹv Kyr",
          "VEB": "Venẽjuvéra Morivar (1871–2008)",
          "VEF": "Venẽjuvéra Morivar (2008–2018)",
          "VES": "Venẽjuvéra Morivar",
          "VND": "Vijétinỹm Nãg",
          "VNN": "Vijétinỹm Nãg (1978–1985)",
          "VUV": "Vanũvatu Vatu",
          "WST": "Samãva Tara",
          "XAF": "Vĩpir CFA tỹ BEAC",
          "XAG": "Kyfé Kupri",
          "XAU": "Kyfé Mỹrér",
          "XBA": "Orópa Vẽnhkãmur ũ ‘e",
          "XBB": "Orópa Jãnkamu ũ-pir (XBB)",
          "XBC": "Orópa Nĩkrén-ja ũ-pir (XBC)",
          "XBD": "Orópa Nĩkrén-ja ũ-pir",
          "XCD": "Karime Rãjur Nórar",
          "XDR": "Kuryj há ty Jiro",
          "XEU": "Orópa Nĩkri ũ-pir",
          "XFO": "Frỹsa Vĩpir-Oro",
          "XFU": "Frỹsa UIC Vĩpir",
          "XOF": "Vĩpir CFA tỹ BCEAO",
          "XPD": "Paranho",
          "XPF": "Vĩpir CFP",
          "XPT": "Pratinỹ",
          "XRE": "RINET Kãryjgy",
          "XSU": "XSU",
          "XTS": "Rá tỹ Nĩkri Vẽnh-kãgran-ja",
          "XUA": "XUA",
          "XXX": "Nĩkri veja tũ",
          "YDD": "Jemẽn Ninỹ",
          "YER": "Jemẽn Hijar",
          "YUD": "Jugusiravija Ninỹ Tar (1966–1990)",
          "YUM": "Jugusiravija Ninỹ Tãg (1994–2002)",
          "YUN": "Jugusiravija Ninỹ ta ũn há (1990–1992)",
          "YUR": "Jugusiravija Ninỹ han mãn tãg (1992–1993)",
          "ZAL": "Ran surafrikỹnũ (virhár)",
          "ZAR": "Ran surafrikỹnũ",
          "ZMK": "Kuvasa Jỹmijanũ (1968–2012)",
          "ZMW": "Kuvasa jỹmijanũ",
          "ZRN": "Jajre Tãg Sajrẽse",
          "ZRZ": "Jajre Sajrẽse (1971–1993)",
          "ZWD": "Jimamuvé Nórar (1980– 2008)",
          "ZWL": "Jimamuvé Nórar (2009)",
          "ZWR": "Jimamuvé Nórar (2008)"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "kurã",
          "dayOfYear": "prỹg kurã ũ kã",
          "dayperiod": "AM/PM",
          "era": "vãsỹ",
          "hour": "óra",
          "minute": "mĩnũtu",
          "month": "kysã",
          "quarter": "kysã-tẽgtũ",
          "second": "segũno",
          "timeZoneName": "ẽmã ũ tá óra",
          "weekOfMonth": "kysã simỹnỹ ũ kã",
          "weekOfYear": "simỹnỹ",
          "weekday": "simỹnỹ kurã ũ kã",
          "weekdayOfMonth": "simỹnỹ kurã ũ kã kysã tag kã",
          "year": "prỹg"
        },
        "narrow": {
          "day": "kurã",
          "dayOfYear": "prỹg kurã ũ kã",
          "dayperiod": "AM/PM",
          "era": "vãsỹ",
          "hour": "h",
          "minute": "mĩn.",
          "month": "kysã",
          "quarter": "kysã-tẽgtũ",
          "second": "seg.",
          "timeZoneName": "tá óra",
          "weekOfMonth": "ysã sim. ũ kã",
          "weekOfYear": "sim.",
          "weekday": "sim. kurã ũ kã",
          "weekdayOfMonth": "sim. kurã ũ kã kysã tag kã",
          "year": "prỹg"
        },
        "short": {
          "day": "kurã",
          "dayOfYear": "prỹg kurã ũ kã",
          "dayperiod": "AM/PM",
          "era": "vãsỹ",
          "hour": "h",
          "minute": "mĩn.",
          "month": "kysã",
          "quarter": "kysã-tẽgtũ",
          "second": "seg.",
          "timeZoneName": "tá óra",
          "weekOfMonth": "kysã sim. ũ kã",
          "weekOfYear": "sim.",
          "weekday": "sim. kurã ũ kã",
          "weekdayOfMonth": "sim. kurã ũ kã kysã tag kã",
          "year": "prỹg"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "afar",
            "ab": "amekaso",
            "ace": "agsẽm",
            "ach": "akori",
            "ada": "anágme",
            "ady": "anhige",
            "ae": "avétiko",
            "af": "afrikỹnẽ",
            "afh": "afrihiri",
            "agq": "aghẽm",
            "ain": "ajinũ",
            "ak": "akỹn",
            "akk": "akajỹnũ",
            "ale": "arevute",
            "alt": "artaj sur",
            "am": "amỹriko",
            "an": "aragonẽ",
            "ang": "ĩnhgrej arkajiku",
            "anp": "ỹgika",
            "ar": "arame",
            "ar-001": "arame ta’ũn",
            "arc": "aramajiko",
            "arn": "mỹpunugũn",
            "arp": "arapaho",
            "ars": "arame nẽgene",
            "arw": "aruvaki",
            "as": "ajamẽ",
            "asa": "asu",
            "ast": "anhturijỹnũ",
            "av": "avariko",
            "awa": "avanhi",
            "ay": "ajimỹra",
            "az": "ajermajỹnũ",
            "az-Arab": "aseri sur",
            "ba": "majkir",
            "bal": "marusi",
            "ban": "marinẽj",
            "bas": "masa",
            "bax": "mamũm",
            "bbj": "gumỹra",
            "be": "huso-kupri",
            "bej": "meja",
            "bem": "mema",
            "bez": "menỹ",
            "bfd": "mafun",
            "bg": "mugaru",
            "bgn": "marusi-rãpurja",
            "bho": "mojpuri",
            "bi": "miramá",
            "bik": "mikor",
            "bin": "minĩ",
            "bkm": "kãm",
            "bla": "sigsika",
            "bm": "mámara",
            "bn": "megari",
            "bo": "timetỹnũ",
            "br": "mretỹ",
            "bra": "mraj",
            "brx": "mono",
            "bs": "mojnia",
            "bss": "akuse",
            "bua": "murijato",
            "bug": "muginẽj",
            "bum": "muru",
            "byn": "mrĩn",
            "byv": "menuma",
            "ca": "katarũg",
            "cad": "kano",
            "car": "karime",
            "cay": "kajuga",
            "cch": "ansỹm",
            "ccp": "sakimỹ",
            "ce": "sesẽnũ",
            "ceb": "semujỹnũ",
            "cgg": "siga",
            "ch": "samãhu",
            "chb": "simsa",
            "chg": "sagataj",
            "chk": "sukese",
            "chm": "mỹri",
            "chn": "jargỹ sinũki",
            "cho": "sogtavo",
            "chp": "sipevyjỹ",
            "chr": "seroki",
            "chy": "sejẽnẽ",
            "ckb": "kurno kuju",
            "co": "korso",
            "cop": "komta",
            "cr": "kri",
            "crh": "krimẽja tá turko",
            "crs": "sejséri krijoro-frỹsej",
            "cs": "séko",
            "csb": "kasumijỹ",
            "cu": "eravu ekresijatiko",
            "cv": "suvase",
            "cy": "garej",
            "da": "nhinỹmỹrkej",
            "dak": "nakota",
            "dar": "narguva",
            "dav": "tajta",
            "de": "arimỹv",
            "de-AT": "arimỹv (Agtirija)",
            "de-CH": "suvisa arimỹv-téj",
            "del": "neravare",
            "den": "sirave",
            "dgr": "nogrim",
            "din": "ninka",
            "dje": "jarma",
            "doi": "nogri",
            "dsb": "soramiv rur",
            "dua": "nuvara",
            "dum": "orỹnej kuju",
            "dv": "nivehi",
            "dyo": "jora-fonyj",
            "dyu": "nhivura",
            "dz": "jãnga",
            "dzg": "najaga",
            "ebu": "ẽmu",
            "ee": "eve",
            "efi": "efike",
            "egy": "ejimso arkajku",
            "eka": "ekajuki",
            "el": "gregu",
            "elx": "eramĩte",
            "en": "ĩnhgrej",
            "en-AU": "ĩnhgrej (Avotyraria)",
            "en-CA": "ĩnhgrej (Kanỹna)",
            "en-GB": "ĩnhgrej (Rejnũ Unĩnu)",
            "en-US": "ĩnhgrej (Enhtano Unĩno)",
            "enm": "ĩnhgrej kuju",
            "eo": "enhperỹtu",
            "es": "enhpỹjór",
            "es-419": "enhpỹjór (Amẽrika Ratinỹ)",
            "es-ES": "enhpỹjór (Enhpỹnija)",
            "es-MX": "enhpỹjór (Mẽsiku)",
            "et": "enhtonĩjỹnũ",
            "eu": "manhku",
            "ewo": "evãnu",
            "fa": "pérsa",
            "fa-AF": "pérsa (Afeganĩtã)",
            "fan": "fỹnge",
            "fat": "fỹti",
            "ff": "fura",
            "fi": "fĩranẽj",
            "fil": "firipĩnũ",
            "fj": "fijỹnũ",
            "fo": "fervej",
            "fon": "fãm",
            "fr": "frỹsej",
            "fr-CA": "frỹsej (Kanỹna)",
            "fr-CH": "frỹsej (Suvisa)",
            "frc": "frỹsej kajũn",
            "frm": "frỹsej kuju",
            "fro": "frỹsej arkajku",
            "frr": "friso tỹ nãrti",
            "frs": "frisỹ rãjur",
            "fur": "frijurỹnũ",
            "fy": "friso rãpur",
            "ga": "irỹnej",
            "gaa": "ga",
            "gag": "gagavuj",
            "gan": "gỹn",
            "gay": "gajo",
            "gba": "gemaja",
            "gd": "gajériko enhkosej",
            "gez": "gij",
            "gil": "gimertej",
            "gl": "garego",
            "gmh": "arimỹv-téj kuju",
            "gn": "góranĩ",
            "goh": "arimỹv-téj arkajku",
            "gon": "gãnni",
            "gor": "gorãntar",
            "got": "gótiko",
            "grb": "gremo",
            "grc": "gregu arkajku",
            "gsw": "arimỹv (Suvisa)",
            "gu": "gujerati",
            "guz": "gusij",
            "gv": "mỹnsi",
            "gwi": "guvisĩn",
            "ha": "havusa",
            "hai": "hajna",
            "hak": "haka",
            "haw": "havajỹnũ",
            "he": "emrajko",
            "hi": "hĩni",
            "hil": "hirigajnãn",
            "hit": "hitita",
            "hmn": "hymãg",
            "ho": "hiri motu",
            "hr": "krovata",
            "hsb": "soramiv téj",
            "hsn": "sijỹg",
            "ht": "hajtijỹnũ",
            "hu": "ũgaru",
            "hup": "hupa",
            "hy": "armẽnĩju",
            "hz": "herero",
            "ia": "vĩ-jãgja",
            "iba": "iman",
            "ibb": "imimijo",
            "id": "ĩnonẽsijo",
            "ie": "vĩ-ag kuju ki",
            "ig": "igmo",
            "ii": "sisuvỹ ji",
            "ik": "ĩnũpijake",
            "ilo": "irukỹnũ",
            "inh": "ĩnguse",
            "io": "ino",
            "is": "kukryr",
            "it": "itarijỹnũ",
            "iu": "inugtituti",
            "ja": "japonẽj",
            "jbo": "rojmán",
            "jgo": "gẽma",
            "jmc": "mỹsame",
            "jpr": "junajko-pérsa",
            "jrb": "junajko-aramiko",
            "jv": "javanẽj",
            "ka": "jiórjijỹnũ",
            "kaa": "kara-karkag",
            "kab": "kamyre",
            "kac": "kasĩn",
            "kaj": "ju",
            "kam": "kỹma",
            "kaw": "kavi",
            "kbd": "kamarnhijỹnũ",
            "kbl": "kanẽnmu",
            "kcg": "tyjam",
            "kde": "mỹkãne",
            "kea": "pu-tánh-vĩ",
            "kfo": "koro",
            "kg": "kãgorej",
            "kgp": "kanhgág",
            "kha": "kasi",
            "kho": "kotanẽj",
            "khq": "kujra sĩnĩ",
            "ki": "kikuju",
            "kj": "kuvanhỹmỹ",
            "kk": "kajake",
            "kkj": "kako",
            "kl": "grohẽrỹnej",
            "kln": "karẽnjĩn",
            "km": "kymẽr",
            "kmb": "kĩmuno",
            "kn": "kanỹrim",
            "ko": "korejỹnũ",
            "koi": "komĩ-permyjag",
            "kok": "kãkani",
            "kos": "kosirajỹn",
            "kpe": "kepere",
            "kr": "kanũri",
            "krc": "karasaj-markar",
            "krl": "karérijo",
            "kru": "kurug",
            "ks": "kasemĩra",
            "ksb": "sỹmara",
            "ksf": "mafija",
            "ksh": "kárysi",
            "ku": "kurno",
            "kum": "kumyg",
            "kut": "kutenaj",
            "kv": "komĩ",
            "kw": "kórnĩko",
            "ky": "kirginh",
            "la": "ratĩnh",
            "lad": "raninũ",
            "lag": "rỹngi",
            "lah": "rahina",
            "lam": "rỹma",
            "lb": "rusẽmurgej",
            "lez": "resgi",
            "lg": "rugỹna",
            "li": "rĩmurgej",
            "lij": "lij",
            "lkt": "rakóta",
            "ln": "rĩgara",
            "lo": "raosijỹnũ",
            "lol": "mãgo",
            "lou": "rovusijỹnỹ tá ke pẽ",
            "loz": "roji",
            "lrc": "ruri nãrti",
            "lt": "rituvỹnũ",
            "lu": "ruma-katỹga",
            "lua": "ruma-ruruva",
            "lui": "rujsẽnũ",
            "lun": "rũna",
            "luo": "ruvo",
            "lus": "rusaj",
            "luy": "ruja",
            "lv": "retỹv",
            "mad": "mỹnurej",
            "maf": "mafa",
            "mag": "mỹgahi",
            "mai": "mỹjtiri",
            "mak": "mỹkasar",
            "man": "mỹnhĩga",
            "mas": "mỹsaj",
            "mde": "mama",
            "mdf": "mogsa",
            "mdr": "mỹnar",
            "men": "mẽne",
            "mer": "mẽru",
            "mfe": "mãrisijẽn",
            "mg": "mỹrgase",
            "mga": "irỹnej kuju",
            "mgh": "mỹkuva",
            "mgo": "mẽta",
            "mh": "mỹrsarej",
            "mi": "mỹvóri",
            "mic": "mĩkemỹke",
            "min": "mĩnỹgkamavu",
            "mk": "mỹsenojũ",
            "ml": "mỹrajara",
            "mn": "mãgór",
            "mnc": "mỹsu",
            "mni": "mỹnĩpuri",
            "moh": "mãjkỹnũ",
            "mos": "mosi",
            "mr": "marati",
            "ms": "mỹrajo",
            "mt": "mỹrtej",
            "mua": "mũnág",
            "mul": "vẽnhvĩ’e",
            "mus": "krig",
            "mwl": "mĩrỹnej",
            "mwr": "mỹrvari",
            "my": "mirmỹnẽj",
            "mye": "myene",
            "myv": "érsija",
            "mzn": "mỹsánarỹni",
            "na": "nỹvuruvánũ",
            "nan": "mĩn nỹn",
            "nap": "nỹporitỹnũ",
            "naq": "nỹmỹ",
            "nb": "mógmỹr nãrovegej",
            "nd": "nemere nãrti",
            "nds": "arimỹv rur",
            "nds-NL": "sagsỹv rur",
            "ne": "nẽparej",
            "new": "nẽvari",
            "ng": "nogã",
            "nia": "nĩja",
            "niu": "nivuvejỹnũ",
            "nl": "orỹnej",
            "nl-BE": "framẽgo",
            "nmg": "kivasijo",
            "nn": "nĩnãrsig nãrovegej",
            "nnh": "gijẽmun",
            "no": "nãrovegej",
            "nog": "nãgaj",
            "non": "nãrniko arkajku",
            "nqo": "nyko",
            "nr": "nemere sur",
            "nso": "soto nãrti",
            "nus": "nũver",
            "nv": "nỹvaho",
            "nwc": "nẽvari há tỹvĩ",
            "ny": "nĩjỹnja",
            "nym": "nyjỹm-vesi",
            "nyn": "nyjỹmkore",
            "nyo": "nyjor",
            "nzi": "nĩsimỹ",
            "oc": "ogsitỹnũ",
            "oj": "ojimva",
            "om": "orãmũ",
            "or": "orija",
            "os": "oseto",
            "osa": "osage",
            "ota": "turko otomỹnũ",
            "pa": "pỹjami",
            "pag": "pangasinỹ",
            "pal": "paravi",
            "pam": "pampỹga",
            "pap": "papijamẽto",
            "pau": "paravỹnũ",
            "pcm": "pingĩn nĩjerijỹnũ",
            "peo": "pérsa arkajku",
            "phn": "fenĩso",
            "pi": "pari",
            "pl": "poronẽj",
            "pon": "pãnhpejỹnũ",
            "prg": "prusijỹnũ",
            "pro": "provẽsar arkajku",
            "ps": "pasito",
            "pt": "fóg-vĩ",
            "pt-BR": "fóg-vĩ (Mrasir)",
            "pt-PT": "fóg-vĩ (Portugar)",
            "qu": "kinsuva",
            "quc": "kisé",
            "raj": "hajanhtỹnĩ",
            "rap": "hapanũj",
            "rar": "harotãganũ",
            "rhg": "rhg",
            "rm": "homỹse",
            "rn": "hũni",
            "ro": "homẽnũ",
            "ro-MD": "mãrnavijo",
            "rof": "hãmo",
            "rom": "homỹnĩ",
            "ru": "huso",
            "rup": "aromẽnũ",
            "rw": "kinĩjarvỹna",
            "rwk": "hywa",
            "sa": "sỹnhkrito",
            "sad": "sỹnave",
            "sah": "saka",
            "sam": "aramỹjko samaritỹnũ",
            "saq": "sỹmuru",
            "sas": "sasag",
            "sat": "sỹtari",
            "sba": "gỹmaji",
            "sbp": "sỹgu",
            "sc": "sarno",
            "scn": "sisirijỹnũ",
            "sco": "isikoti",
            "sd": "sĩni",
            "sdh": "kurno sur",
            "se": "samĩ nãrti",
            "see": "senẽka",
            "seh": "senỹ",
            "sel": "serkum",
            "ses": "kojyramoro senĩ",
            "sg": "sỹgo",
            "sga": "irỹnej arkajku",
            "sh": "servo-krovata",
            "shi": "tasehiti",
            "shn": "sỹn",
            "shu": "arame sanijỹnũ",
            "si": "sĩgarej",
            "sid": "sinamũ",
            "sk": "erovako",
            "sl": "erovenũ",
            "sm": "samovỹnũ",
            "sma": "samĩ sur",
            "smj": "samĩ Rure tá",
            "smn": "samĩ Inari tá",
            "sms": "samĩ Isikórti tá",
            "sn": "sãnỹ",
            "snk": "sãnĩke",
            "so": "somỹri",
            "sog": "sognijỹnũ",
            "sq": "armánẽj",
            "sr": "sérvijo",
            "srn": "surinỹmẽj",
            "srr": "serere",
            "ss": "suvaji",
            "ssy": "saho",
            "st": "soto sur",
            "su": "sunanẽj",
            "suk": "sukumỹ",
            "sus": "susu",
            "sux": "sumẽrijo",
            "sv": "suvéko",
            "sw": "suvahiri",
            "sw-CD": "suvahiri Kãgo tá",
            "swb": "komorijỹnũ",
            "syc": "sirijako há tỹvĩ",
            "syr": "sirijako",
            "ta": "támĩr",
            "te": "térugo",
            "tem": "timnẽ",
            "teo": "teso",
            "ter": "terẽnũ",
            "tet": "tétũm",
            "tg": "tanhike",
            "th": "tajrỹnej",
            "ti": "tigrinĩja",
            "tig": "tigré",
            "tiv": "tivi",
            "tk": "turkomẽnũ",
            "tkl": "tokeravánũ",
            "tl": "tagaro",
            "tlh": "krĩngãg",
            "tli": "tiringite",
            "tmh": "tamỹséke",
            "tn": "tisuvanỹ",
            "to": "tãnganẽj",
            "tog": "tãnganẽj Nyjasa tá",
            "tpi": "tóg-pisĩn",
            "tr": "turko",
            "trv": "taroko",
            "ts": "tesãga",
            "tsi": "simsijỹnũ",
            "tt": "tartaru",
            "tum": "tũmuka",
            "tvl": "tuvaruvỹnũ",
            "tw": "tuvi",
            "twq": "tasavag",
            "ty": "tajtijỹnũ",
            "tyv": "tuvinijỹnũ",
            "tzm": "tamỹjirte Atara Kuju tá",
            "udm": "unmũrte",
            "ug": "ujgur",
            "uga": "ugaritiko",
            "uk": "ukranĩjỹnũ",
            "umb": "ũmunu",
            "und": "vẽnhvĩ ki kagtĩg",
            "ur": "urnu",
            "uz": "unhmeke",
            "vai": "vaj",
            "ve": "vẽna",
            "vi": "vijétinỹmũ",
            "vo": "vorapuke",
            "vot": "vótiko",
            "vun": "vũjo",
            "wa": "varỹv",
            "wae": "varser",
            "wal": "vorajta",
            "war": "varaj",
            "was": "vaso",
            "wbp": "varpiri",
            "wo": "vorofe",
            "wuu": "vu",
            "xal": "karmĩg",
            "xh": "sosa",
            "xog": "rusoga",
            "yao": "javo",
            "yap": "japese",
            "yav": "jỹgmen",
            "ybb": "jẽma",
            "yi": "jinhise",
            "yo": "joruma",
            "yrl": "nhẽgatu",
            "yue": "kỹtonẽj",
            "za": "juvỹg",
            "zap": "japoteko",
            "zbl": "sĩmoru mrij",
            "zen": "senỹga",
            "zgh": "tamỹjirte mỹhókinũ pã",
            "zh": "sĩnẽj",
            "zh-Hans": "sĩnẽj mẽ",
            "zh-Hant": "sĩnẽj pẽ",
            "zu": "suru",
            "zun": "sunhi",
            "zxx": "nén ũ vẽnhvĩ ki tũ",
            "zza": "sasaki"
          },
          "narrow": {
          },
          "short": {
            "az": "ajermajỹnũ",
            "en-GB": "ĩnhgrej (Rejnũ Unĩnu)",
            "en-US": "ĩnhgrej (EUA)"
          }
        },
        "standard": {
          "long": {
            "aa": "afar",
            "ab": "amekaso",
            "ace": "agsẽm",
            "ach": "akori",
            "ada": "anágme",
            "ady": "anhige",
            "ae": "avétiko",
            "af": "afrikỹnẽ",
            "afh": "afrihiri",
            "agq": "aghẽm",
            "ain": "ajinũ",
            "ak": "akỹn",
            "akk": "akajỹnũ",
            "ale": "arevute",
            "alt": "artaj sur",
            "am": "amỹriko",
            "an": "aragonẽ",
            "ang": "ĩnhgrej arkajiku",
            "anp": "ỹgika",
            "ar": "arame",
            "ar-001": "arame (Tã mĩ ke kar)",
            "arc": "aramajiko",
            "arn": "mỹpunugũn",
            "arp": "arapaho",
            "ars": "arame nẽgene",
            "arw": "aruvaki",
            "as": "ajamẽ",
            "asa": "asu",
            "ast": "anhturijỹnũ",
            "av": "avariko",
            "awa": "avanhi",
            "ay": "ajimỹra",
            "az": "ajermajỹnũ",
            "az-Arab": "aseri sur",
            "ba": "majkir",
            "bal": "marusi",
            "ban": "marinẽj",
            "bas": "masa",
            "bax": "mamũm",
            "bbj": "gumỹra",
            "be": "huso-kupri",
            "bej": "meja",
            "bem": "mema",
            "bez": "menỹ",
            "bfd": "mafun",
            "bg": "mugaru",
            "bgn": "marusi-rãpurja",
            "bho": "mojpuri",
            "bi": "miramá",
            "bik": "mikor",
            "bin": "minĩ",
            "bkm": "kãm",
            "bla": "sigsika",
            "bm": "mámara",
            "bn": "megari",
            "bo": "timetỹnũ",
            "br": "mretỹ",
            "bra": "mraj",
            "brx": "mono",
            "bs": "mojnia",
            "bss": "akuse",
            "bua": "murijato",
            "bug": "muginẽj",
            "bum": "muru",
            "byn": "mrĩn",
            "byv": "menuma",
            "ca": "katarũg",
            "cad": "kano",
            "car": "karime",
            "cay": "kajuga",
            "cch": "ansỹm",
            "ccp": "sakimỹ",
            "ce": "sesẽnũ",
            "ceb": "semujỹnũ",
            "cgg": "siga",
            "ch": "samãhu",
            "chb": "simsa",
            "chg": "sagataj",
            "chk": "sukese",
            "chm": "mỹri",
            "chn": "jargỹ sinũki",
            "cho": "sogtavo",
            "chp": "sipevyjỹ",
            "chr": "seroki",
            "chy": "sejẽnẽ",
            "ckb": "kurno kuju",
            "co": "korso",
            "cop": "komta",
            "cr": "kri",
            "crh": "krimẽja tá turko",
            "crs": "sejséri krijoro-frỹsej",
            "cs": "séko",
            "csb": "kasumijỹ",
            "cu": "eravu ekresijatiko",
            "cv": "suvase",
            "cy": "garej",
            "da": "nhinỹmỹrkej",
            "dak": "nakota",
            "dar": "narguva",
            "dav": "tajta",
            "de": "arimỹv",
            "de-AT": "arimỹv (Agtirija)",
            "de-CH": "arimỹv (Suvisa)",
            "del": "neravare",
            "den": "sirave",
            "dgr": "nogrim",
            "din": "ninka",
            "dje": "jarma",
            "doi": "nogri",
            "dsb": "soramiv rur",
            "dua": "nuvara",
            "dum": "orỹnej kuju",
            "dv": "nivehi",
            "dyo": "jora-fonyj",
            "dyu": "nhivura",
            "dz": "jãnga",
            "dzg": "najaga",
            "ebu": "ẽmu",
            "ee": "eve",
            "efi": "efike",
            "egy": "ejimso arkajku",
            "eka": "ekajuki",
            "el": "gregu",
            "elx": "eramĩte",
            "en": "ĩnhgrej",
            "en-AU": "ĩnhgrej (Avotyraria)",
            "en-CA": "ĩnhgrej (Kanỹna)",
            "en-GB": "ĩnhgrej (Rejnũ Unĩnu)",
            "en-US": "ĩnhgrej (Enhtano Unĩno)",
            "enm": "ĩnhgrej kuju",
            "eo": "enhperỹtu",
            "es": "enhpỹjór",
            "es-419": "enhpỹjór (Amẽrika Ratinỹ)",
            "es-ES": "enhpỹjór (Enhpỹnija)",
            "es-MX": "enhpỹjór (Mẽsiku)",
            "et": "enhtonĩjỹnũ",
            "eu": "manhku",
            "ewo": "evãnu",
            "fa": "pérsa",
            "fa-AF": "pérsa (Afeganĩtã)",
            "fan": "fỹnge",
            "fat": "fỹti",
            "ff": "fura",
            "fi": "fĩranẽj",
            "fil": "firipĩnũ",
            "fj": "fijỹnũ",
            "fo": "fervej",
            "fon": "fãm",
            "fr": "frỹsej",
            "fr-CA": "frỹsej (Kanỹna)",
            "fr-CH": "frỹsej (Suvisa)",
            "frc": "frỹsej kajũn",
            "frm": "frỹsej kuju",
            "fro": "frỹsej arkajku",
            "frr": "friso tỹ nãrti",
            "frs": "frisỹ rãjur",
            "fur": "frijurỹnũ",
            "fy": "friso rãpur",
            "ga": "irỹnej",
            "gaa": "ga",
            "gag": "gagavuj",
            "gan": "gỹn",
            "gay": "gajo",
            "gba": "gemaja",
            "gd": "gajériko enhkosej",
            "gez": "gij",
            "gil": "gimertej",
            "gl": "garego",
            "gmh": "arimỹv-téj kuju",
            "gn": "góranĩ",
            "goh": "arimỹv-téj arkajku",
            "gon": "gãnni",
            "gor": "gorãntar",
            "got": "gótiko",
            "grb": "gremo",
            "grc": "gregu arkajku",
            "gsw": "arimỹv (Suvisa)",
            "gu": "gujerati",
            "guz": "gusij",
            "gv": "mỹnsi",
            "gwi": "guvisĩn",
            "ha": "havusa",
            "hai": "hajna",
            "hak": "haka",
            "haw": "havajỹnũ",
            "he": "emrajko",
            "hi": "hĩni",
            "hil": "hirigajnãn",
            "hit": "hitita",
            "hmn": "hymãg",
            "ho": "hiri motu",
            "hr": "krovata",
            "hsb": "soramiv téj",
            "hsn": "sijỹg",
            "ht": "hajtijỹnũ",
            "hu": "ũgaru",
            "hup": "hupa",
            "hy": "armẽnĩju",
            "hz": "herero",
            "ia": "vĩ-jãgja",
            "iba": "iman",
            "ibb": "imimijo",
            "id": "ĩnonẽsijo",
            "ie": "vĩ-ag kuju ki",
            "ig": "igmo",
            "ii": "sisuvỹ ji",
            "ik": "ĩnũpijake",
            "ilo": "irukỹnũ",
            "inh": "ĩnguse",
            "io": "ino",
            "is": "kukryr",
            "it": "itarijỹnũ",
            "iu": "inugtituti",
            "ja": "japonẽj",
            "jbo": "rojmán",
            "jgo": "gẽma",
            "jmc": "mỹsame",
            "jpr": "junajko-pérsa",
            "jrb": "junajko-aramiko",
            "jv": "javanẽj",
            "ka": "jiórjijỹnũ",
            "kaa": "kara-karkag",
            "kab": "kamyre",
            "kac": "kasĩn",
            "kaj": "ju",
            "kam": "kỹma",
            "kaw": "kavi",
            "kbd": "kamarnhijỹnũ",
            "kbl": "kanẽnmu",
            "kcg": "tyjam",
            "kde": "mỹkãne",
            "kea": "pu-tánh-vĩ",
            "kfo": "koro",
            "kg": "kãgorej",
            "kgp": "kanhgág",
            "kha": "kasi",
            "kho": "kotanẽj",
            "khq": "kujra sĩnĩ",
            "ki": "kikuju",
            "kj": "kuvanhỹmỹ",
            "kk": "kajake",
            "kkj": "kako",
            "kl": "grohẽrỹnej",
            "kln": "karẽnjĩn",
            "km": "kymẽr",
            "kmb": "kĩmuno",
            "kn": "kanỹrim",
            "ko": "korejỹnũ",
            "koi": "komĩ-permyjag",
            "kok": "kãkani",
            "kos": "kosirajỹn",
            "kpe": "kepere",
            "kr": "kanũri",
            "krc": "karasaj-markar",
            "krl": "karérijo",
            "kru": "kurug",
            "ks": "kasemĩra",
            "ksb": "sỹmara",
            "ksf": "mafija",
            "ksh": "kárysi",
            "ku": "kurno",
            "kum": "kumyg",
            "kut": "kutenaj",
            "kv": "komĩ",
            "kw": "kórnĩko",
            "ky": "kirginh",
            "la": "ratĩnh",
            "lad": "raninũ",
            "lag": "rỹngi",
            "lah": "rahina",
            "lam": "rỹma",
            "lb": "rusẽmurgej",
            "lez": "resgi",
            "lg": "rugỹna",
            "li": "rĩmurgej",
            "lij": "lij",
            "lkt": "rakóta",
            "ln": "rĩgara",
            "lo": "raosijỹnũ",
            "lol": "mãgo",
            "lou": "rovusijỹnỹ tá ke pẽ",
            "loz": "roji",
            "lrc": "ruri nãrti",
            "lt": "rituvỹnũ",
            "lu": "ruma-katỹga",
            "lua": "ruma-ruruva",
            "lui": "rujsẽnũ",
            "lun": "rũna",
            "luo": "ruvo",
            "lus": "rusaj",
            "luy": "ruja",
            "lv": "retỹv",
            "mad": "mỹnurej",
            "maf": "mafa",
            "mag": "mỹgahi",
            "mai": "mỹjtiri",
            "mak": "mỹkasar",
            "man": "mỹnhĩga",
            "mas": "mỹsaj",
            "mde": "mama",
            "mdf": "mogsa",
            "mdr": "mỹnar",
            "men": "mẽne",
            "mer": "mẽru",
            "mfe": "mãrisijẽn",
            "mg": "mỹrgase",
            "mga": "irỹnej kuju",
            "mgh": "mỹkuva",
            "mgo": "mẽta",
            "mh": "mỹrsarej",
            "mi": "mỹvóri",
            "mic": "mĩkemỹke",
            "min": "mĩnỹgkamavu",
            "mk": "mỹsenojũ",
            "ml": "mỹrajara",
            "mn": "mãgór",
            "mnc": "mỹsu",
            "mni": "mỹnĩpuri",
            "moh": "mãjkỹnũ",
            "mos": "mosi",
            "mr": "marati",
            "ms": "mỹrajo",
            "mt": "mỹrtej",
            "mua": "mũnág",
            "mul": "vẽnhvĩ’e",
            "mus": "krig",
            "mwl": "mĩrỹnej",
            "mwr": "mỹrvari",
            "my": "mirmỹnẽj",
            "mye": "myene",
            "myv": "érsija",
            "mzn": "mỹsánarỹni",
            "na": "nỹvuruvánũ",
            "nan": "mĩn nỹn",
            "nap": "nỹporitỹnũ",
            "naq": "nỹmỹ",
            "nb": "mógmỹr nãrovegej",
            "nd": "nemere nãrti",
            "nds": "arimỹv rur",
            "nds-NL": "arimỹv rur (Pajisi Rur)",
            "ne": "nẽparej",
            "new": "nẽvari",
            "ng": "nogã",
            "nia": "nĩja",
            "niu": "nivuvejỹnũ",
            "nl": "orỹnej",
            "nl-BE": "orỹnej (Mérjika)",
            "nmg": "kivasijo",
            "nn": "nĩnãrsig nãrovegej",
            "nnh": "gijẽmun",
            "no": "nãrovegej",
            "nog": "nãgaj",
            "non": "nãrniko arkajku",
            "nqo": "nyko",
            "nr": "nemere sur",
            "nso": "soto nãrti",
            "nus": "nũver",
            "nv": "nỹvaho",
            "nwc": "nẽvari há tỹvĩ",
            "ny": "nĩjỹnja",
            "nym": "nyjỹm-vesi",
            "nyn": "nyjỹmkore",
            "nyo": "nyjor",
            "nzi": "nĩsimỹ",
            "oc": "ogsitỹnũ",
            "oj": "ojimva",
            "om": "orãmũ",
            "or": "orija",
            "os": "oseto",
            "osa": "osage",
            "ota": "turko otomỹnũ",
            "pa": "pỹjami",
            "pag": "pangasinỹ",
            "pal": "paravi",
            "pam": "pampỹga",
            "pap": "papijamẽto",
            "pau": "paravỹnũ",
            "pcm": "pingĩn nĩjerijỹnũ",
            "peo": "pérsa arkajku",
            "phn": "fenĩso",
            "pi": "pari",
            "pl": "poronẽj",
            "pon": "pãnhpejỹnũ",
            "prg": "prusijỹnũ",
            "pro": "provẽsar arkajku",
            "ps": "pasito",
            "pt": "fóg-vĩ",
            "pt-BR": "fóg-vĩ (Mrasir)",
            "pt-PT": "fóg-vĩ (Portugar)",
            "qu": "kinsuva",
            "quc": "kisé",
            "raj": "hajanhtỹnĩ",
            "rap": "hapanũj",
            "rar": "harotãganũ",
            "rhg": "rhg",
            "rm": "homỹse",
            "rn": "hũni",
            "ro": "homẽnũ",
            "ro-MD": "homẽnũ (Mãrnova)",
            "rof": "hãmo",
            "rom": "homỹnĩ",
            "ru": "huso",
            "rup": "aromẽnũ",
            "rw": "kinĩjarvỹna",
            "rwk": "hywa",
            "sa": "sỹnhkrito",
            "sad": "sỹnave",
            "sah": "saka",
            "sam": "aramỹjko samaritỹnũ",
            "saq": "sỹmuru",
            "sas": "sasag",
            "sat": "sỹtari",
            "sba": "gỹmaji",
            "sbp": "sỹgu",
            "sc": "sarno",
            "scn": "sisirijỹnũ",
            "sco": "isikoti",
            "sd": "sĩni",
            "sdh": "kurno sur",
            "se": "samĩ nãrti",
            "see": "senẽka",
            "seh": "senỹ",
            "sel": "serkum",
            "ses": "kojyramoro senĩ",
            "sg": "sỹgo",
            "sga": "irỹnej arkajku",
            "sh": "servo-krovata",
            "shi": "tasehiti",
            "shn": "sỹn",
            "shu": "arame sanijỹnũ",
            "si": "sĩgarej",
            "sid": "sinamũ",
            "sk": "erovako",
            "sl": "erovenũ",
            "sm": "samovỹnũ",
            "sma": "samĩ sur",
            "smj": "samĩ Rure tá",
            "smn": "samĩ Inari tá",
            "sms": "samĩ Isikórti tá",
            "sn": "sãnỹ",
            "snk": "sãnĩke",
            "so": "somỹri",
            "sog": "sognijỹnũ",
            "sq": "armánẽj",
            "sr": "sérvijo",
            "srn": "surinỹmẽj",
            "srr": "serere",
            "ss": "suvaji",
            "ssy": "saho",
            "st": "soto sur",
            "su": "sunanẽj",
            "suk": "sukumỹ",
            "sus": "susu",
            "sux": "sumẽrijo",
            "sv": "suvéko",
            "sw": "suvahiri",
            "sw-CD": "suvahiri (Kãgo - Kĩsaja)",
            "swb": "komorijỹnũ",
            "syc": "sirijako há tỹvĩ",
            "syr": "sirijako",
            "ta": "támĩr",
            "te": "térugo",
            "tem": "timnẽ",
            "teo": "teso",
            "ter": "terẽnũ",
            "tet": "tétũm",
            "tg": "tanhike",
            "th": "tajrỹnej",
            "ti": "tigrinĩja",
            "tig": "tigré",
            "tiv": "tivi",
            "tk": "turkomẽnũ",
            "tkl": "tokeravánũ",
            "tl": "tagaro",
            "tlh": "krĩngãg",
            "tli": "tiringite",
            "tmh": "tamỹséke",
            "tn": "tisuvanỹ",
            "to": "tãnganẽj",
            "tog": "tãnganẽj Nyjasa tá",
            "tpi": "tóg-pisĩn",
            "tr": "turko",
            "trv": "taroko",
            "ts": "tesãga",
            "tsi": "simsijỹnũ",
            "tt": "tartaru",
            "tum": "tũmuka",
            "tvl": "tuvaruvỹnũ",
            "tw": "tuvi",
            "twq": "tasavag",
            "ty": "tajtijỹnũ",
            "tyv": "tuvinijỹnũ",
            "tzm": "tamỹjirte Atara Kuju tá",
            "udm": "unmũrte",
            "ug": "ujgur",
            "uga": "ugaritiko",
            "uk": "ukranĩjỹnũ",
            "umb": "ũmunu",
            "und": "vẽnhvĩ ki kagtĩg",
            "ur": "urnu",
            "uz": "unhmeke",
            "vai": "vaj",
            "ve": "vẽna",
            "vi": "vijétinỹmũ",
            "vo": "vorapuke",
            "vot": "vótiko",
            "vun": "vũjo",
            "wa": "varỹv",
            "wae": "varser",
            "wal": "vorajta",
            "war": "varaj",
            "was": "vaso",
            "wbp": "varpiri",
            "wo": "vorofe",
            "wuu": "vu",
            "xal": "karmĩg",
            "xh": "sosa",
            "xog": "rusoga",
            "yao": "javo",
            "yap": "japese",
            "yav": "jỹgmen",
            "ybb": "jẽma",
            "yi": "jinhise",
            "yo": "joruma",
            "yrl": "nhẽgatu",
            "yue": "kỹtonẽj",
            "za": "juvỹg",
            "zap": "japoteko",
            "zbl": "sĩmoru mrij",
            "zen": "senỹga",
            "zgh": "tamỹjirte mỹhókinũ pã",
            "zh": "sĩnẽj",
            "zh-Hans": "sĩnẽj mẽ",
            "zh-Hant": "sĩnẽj pẽ",
            "zu": "suru",
            "zun": "sunhi",
            "zxx": "nén ũ vẽnhvĩ ki tũ",
            "zza": "sasaki"
          },
          "narrow": {
          },
          "short": {
            "az": "ajermajỹnũ",
            "en-GB": "ĩnhgrej (Rejnũ Unĩnu)",
            "en-US": "ĩnhgrej (EUA)"
          }
        }
      },
      "region": {
        "long": {
          "001": "Tã mĩ ke kar",
          "002": "Afrika",
          "003": "Nãrti-Amẽrika",
          "005": "Sur-Amẽrika",
          "009": "Oseanĩja",
          "011": "Afrika Rãpur",
          "013": "Amẽrika-Kuju",
          "014": "Afrika Rãjur",
          "015": "Nãrti-Afrika",
          "017": "Afrika-Kuju",
          "018": "Afrika Mẽrinhonỹr",
          "019": "Amẽrika ag",
          "021": "Amẽrika Setẽntrionỹr",
          "029": "Karime",
          "030": "Ajia Rãjur",
          "034": "Ajia Mẽrinhonỹr",
          "035": "Ajia Sur-Rãjur",
          "039": "Orópa Mẽrinhonỹr",
          "053": "Ausitrarajia",
          "054": "Mẽranẽjia",
          "057": "Mĩkronẽjia Pénĩn",
          "061": "Porinẽjia",
          "142": "Ajia",
          "143": "Ajia-Kuju",
          "145": "Ajia-Rãpur",
          "150": "Orópa",
          "151": "Orópa-Rãjur",
          "154": "Orópa Setẽntrionỹr",
          "155": "Orópa Rãpur",
          "202": "Afrika Sahara-Jẽgu",
          "419": "Amẽrika Ratinỹ",
          "AC": "Asẽnsỹv Goj-vẽso",
          "AD": "Ỹnora",
          "AE": "Emĩrano Arame Unĩno",
          "AF": "Afeganĩtã",
          "AG": "Ỹntiguva kar Marmuna",
          "AI": "Ỹngira",
          "AL": "Armánĩja",
          "AM": "Armẽnĩja",
          "AO": "Ỹgóra",
          "AQ": "Ỹntartina",
          "AR": "Arjẽtinỹ",
          "AS": "Samãva Amẽrikynỹ",
          "AT": "Agtirija",
          "AU": "Avotyraria",
          "AW": "Aruma",
          "AX": "Gojga Goj-vẽso",
          "AZ": "Ajermajjáv",
          "BA": "Mósinĩja",
          "BB": "Juvã-mág",
          "BD": "Mágranési",
          "BE": "Mérjika",
          "BF": "Murkinỹ Faso",
          "BG": "Murgarjia",
          "BH": "Marẽj",
          "BI": "Murũni",
          "BJ": "Menĩnh",
          "BL": "Sỹ Martoromeu",
          "BM": "Mermũna",
          "BN": "Mrunẽj",
          "BO": "Morivija",
          "BQ": "Pajisi Rur Karimejã",
          "BR": "Mrasir",
          "BS": "Mahámỹ",
          "BT": "Mutỹv",
          "BV": "Muve Goj-vẽso",
          "BW": "Monsuvỹnỹ",
          "BY": "Miero-Husija",
          "BZ": "Merije",
          "CA": "Kanỹna",
          "CC": "Kokonh Goj-vẽso (Killing)",
          "CD": "Kãgo - Kĩsaja",
          "CF": "Afrikanỹ-kuju Repumrika",
          "CG": "Kãgo Repumrika",
          "CH": "Suvisa",
          "CI": "Jãn-mág-kupri Fyr",
          "CK": "Kuki Goj-vẽso",
          "CL": "Sire",
          "CM": "Kamỹrãj",
          "CN": "Sĩnỹ",
          "CO": "Korãmija",
          "CP": "Kripertãn Goj-vẽso",
          "CR": "Konhta Rika",
          "CU": "Kuma",
          "CV": "Pu Tánh",
          "CW": "Kurasavo",
          "CX": "Krĩtimỹnh Goj-vẽso",
          "CY": "Sipre",
          "CZ": "Sékija",
          "DE": "Aremỹija",
          "DG": "Niego Garsija",
          "DJ": "Nhimuti",
          "DK": "Ninỹmỹrka",
          "DM": "Nomĩnĩka",
          "DO": "Repumrika Nomĩnĩkỹnỹ",
          "DZ": "Arjérija",
          "EA": "Sevuta kar Mẽrira",
          "EC": "Ekuvanor",
          "EE": "Enhtonĩja",
          "EG": "Ejito",
          "EH": "Sahara Rãpur",
          "ER": "Erytiréja",
          "ES": "Enhpỹnija",
          "ET": "Etiópija",
          "EU": "Unĩjáv Oropéja",
          "EZ": "Evoro Ga",
          "FI": "Fĩrỹnija",
          "FJ": "Fiji",
          "FK": "Mỹrvĩnỹ Goj-vẽso",
          "FM": "Goj-vẽso-sĩ Kẽsir",
          "FO": "Faróve Goj-vẽso",
          "FR": "Frỹsa",
          "GA": "Gabã",
          "GB": "Rejnũ Unĩnu",
          "GD": "Granỹna",
          "GE": "Jiórja",
          "GF": "Frỹsa Gijanỹ",
          "GG": "Gérnesej",
          "GH": "Ganỹ",
          "GI": "Gimrar-tar",
          "GL": "Groẽrỹnija",
          "GM": "Gỹmija",
          "GN": "Ginẽ",
          "GP": "Guvanarupe",
          "GQ": "Ginẽ Ekuvatoriar",
          "GR": "Grésa",
          "GS": "Jiórja-Sur kar Sỹnvisi-Sur Goj-vẽso Ag",
          "GT": "Guvatimỹra",
          "GU": "Guvỹm",
          "GW": "Ginẽ-Misav",
          "GY": "Gijỹnỹ",
          "HK": "Hãg Kãg, Sinỹ ERA",
          "HM": "Hárni kar Magtonarni Goj-vẽso Ag",
          "HN": "Hãnura",
          "HR": "Kroasa",
          "HT": "Ajti",
          "HU": "Ũgrija",
          "IC": "Kanỹrija Goj-vẽso",
          "ID": "Ĩnonẽja",
          "IE": "Irỹna",
          "IL": "Isihaé",
          "IM": "Mỹn Goj-vẽso",
          "IN": "Ĩnija",
          "IO": "Osiỹno Ĩniko tỹ Tehitórijo Mritỹnĩku",
          "IQ": "Iraki",
          "IR": "Irỹ",
          "IS": "Inhrỹnija",
          "IT": "Itarija",
          "JE": "Jérsej",
          "JM": "Jamỹjka",
          "JO": "Jornánĩja",
          "JP": "Japã",
          "KE": "Kenĩja",
          "KG": "Kirginhtỹv",
          "KH": "Kỹmója",
          "KI": "Kirimati",
          "KM": "Komãre",
          "KN": "Sỹ Krinhtóvỹv kar Nẽvinh",
          "KP": "Nãrti-Koréja",
          "KR": "Sur-Koréja",
          "KW": "Kuvajti",
          "KY": "Kajmỹm Goj-vẽso",
          "KZ": "Kajakinhtỹv",
          "LA": "Raosi",
          "LB": "Rimanã",
          "LC": "Sỹta Rusija",
          "LI": "Rinhsiténh-tajin",
          "LK": "Siri Rỹnka",
          "LR": "Rimérija",
          "LS": "Resotu",
          "LT": "Rituỹnĩja",
          "LU": "Rusẽmurgu",
          "LV": "Retãnĩja",
          "LY": "Rimija",
          "MA": "Mỹhókonh",
          "MC": "Mãnỹko",
          "MD": "Mãrnova",
          "ME": "Krĩsá",
          "MF": "Sỹ Mỹrtĩjũ",
          "MG": "Mỹnaganhtar",
          "MH": "MỹrSar Goj-vẽso",
          "MK": "Nãrti-Mỹsenonĩja",
          "ML": "Mỹri",
          "MM": "Mĩjỹmỹr",
          "MN": "Mãngórija",
          "MO": "Mỹkav, Sĩnỹ ERA",
          "MP": "Nãrti-Mỹrijỹnỹ Goj-vẽso",
          "MQ": "Mỹrtinĩka",
          "MR": "Mãritỹnĩja",
          "MS": "Mãtisehati",
          "MT": "Mỹrta",
          "MU": "Mãriso",
          "MV": "Mỹrniva",
          "MW": "Mỹravi",
          "MX": "Mẽsiku",
          "MY": "Mỹraja",
          "MZ": "Mãsỹmiki",
          "NA": "Nỹmĩmija",
          "NC": "Karenonĩja Tãg",
          "NE": "Nĩjer",
          "NF": "Nãrforki Goj-vẽso",
          "NG": "Nĩjérija",
          "NI": "Nĩkaragva",
          "NL": "Pajisi Rur",
          "NO": "Nãrovéga",
          "NP": "Nẽpar",
          "NR": "Nỹuru",
          "NU": "Nĩvue",
          "NZ": "Jerỹnija Tãg",
          "OM": "Omỹ",
          "PA": "Panỹmỹ",
          "PE": "Piru",
          "PF": "Frỹsa Porinẽja",
          "PG": "Papuva-Ginẽ Tãg",
          "PH": "Firipinỹ",
          "PK": "Pakinhtỹv",
          "PL": "Porãnija",
          "PM": "Sỹ Penru kar Mĩkerỹv",
          "PN": "Pinkajir Goj-vẽso",
          "PR": "Portu Hiku",
          "PS": "Tehitórijo Parenhtinũ",
          "PT": "Portugar",
          "PW": "Paravu",
          "PY": "Paraguvaj",
          "QA": "Katar",
          "QO": "Osiỹnĩja Kuvar-gy",
          "RE": "Hujáv",
          "RO": "Homẽnĩja",
          "RS": "Sérvija",
          "RU": "Husija",
          "RW": "Huỹna",
          "SA": "Aramija Savnita",
          "SB": "Saromỹv Goj-vẽso",
          "SC": "Sejserenh",
          "SD": "Suná",
          "SE": "Suésa",
          "SG": "Sĩgapura",
          "SH": "Sỹnta Erenỹ",
          "SI": "Enhrovenĩja",
          "SJ": "Inhvarmarni kar Jan Mỹjẽn",
          "SK": "Enhrovakija",
          "SL": "Krĩ Mĩgkusũg-fi",
          "SM": "Sỹ Mỹrĩnũ",
          "SN": "Senẽgar",
          "SO": "Somỹrija",
          "SR": "Surinỹmĩ",
          "SS": "Sur-Sunáv",
          "ST": "Sỹ Tomẽ kar Prĩsipi",
          "SV": "Er Sarvanor",
          "SX": "Sĩti Mỹ’artẽn",
          "SY": "Sirija",
          "SZ": "Esuatinĩ",
          "TA": "Trinhtỹv Nakũja",
          "TC": "Turka kar Kajko Goj-vẽso Ag",
          "TD": "Sane",
          "TF": "Sur Frỹsa Tehitórijo",
          "TG": "Togo",
          "TH": "Taj-Ga",
          "TJ": "Tanijikinhtỹv",
          "TK": "Tokeravu",
          "TL": "Timãr-Rãjur",
          "TM": "Turkomẽnĩnhtỹv",
          "TN": "Tunĩja",
          "TO": "Tãga",
          "TR": "Turkija",
          "TT": "Trĩnane kar Tomagu",
          "TV": "Tuvaru",
          "TW": "Tajuvỹ",
          "TZ": "Tỹnjỹnĩja",
          "UA": "Ukrỹnĩja",
          "UG": "Ugỹna",
          "UM": "EUA Goj-vẽso Kãsir",
          "UN": "Nỹsãn Unĩna",
          "US": "Enhtano Unĩno",
          "UY": "Urugvaj",
          "UZ": "Unhmekinhtỹv",
          "VA": "Vatikỹnũ Emã-mág",
          "VC": "Sỹ Visenti kar Granỹninỹ",
          "VE": "Venẽjuvéra",
          "VG": "Mritỹnĩja Goj-vẽso",
          "VI": "Virjĩg Goj-vẽso tỹ Amẽrikỹnỹ",
          "VN": "Vijétinỹ",
          "VU": "Vanũvatu",
          "WF": "Varinh kar Futunỹ",
          "WS": "Samãva",
          "XA": "Ón vĩ ag",
          "XB": "Ón régre mĩ.",
          "XK": "Kosovo",
          "YE": "Jemẽn",
          "YT": "Mỹjóte",
          "ZA": "Sur-Afrika",
          "ZM": "Jỹmija",
          "ZW": "Jĩmamuje",
          "ZZ": "Reji’ỹv Veja tũ"
        },
        "narrow": {
        },
        "short": {
          "GB": "Rejnũ Unĩnu",
          "HK": "Hãg Kãg",
          "MO": "Mỹkav",
          "PS": "Parenhtinỹ",
          "UN": "ONU",
          "US": "EUA"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "arame",
          "Aran": "Aran",
          "Armi": "armĩ",
          "Armn": "armẽnjo",
          "Avst": "avénhko",
          "Bali": "marinẽj",
          "Bamu": "mamũm",
          "Bass": "Bass",
          "Batk": "mataki",
          "Beng": "megari",
          "Bhks": "Bhks",
          "Blis": "sĩmuru mrij",
          "Bopo": "mopomãfo",
          "Brah": "mramĩ",
          "Brai": "mrajiri",
          "Bugi": "mugnẽj",
          "Buhd": "muhin",
          "Cakm": "kagme",
          "Cans": "sirama-vẽnhrá pir kanỹna tá kanhgág",
          "Cari": "karijỹnũ",
          "Cham": "sỹm",
          "Cher": "seroki",
          "Chrs": "Chrs",
          "Cirt": "sirti",
          "Copt": "kómtiko",
          "Cpmn": "Cpmn",
          "Cprt": "siprijota",
          "Cyrl": "siririko",
          "Cyrs": "siririko esiravo ekresijatiko",
          "Deva": "nevanỹgari",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "nesereti",
          "Dupl": "Dupl",
          "Egyd": "nemãtiko ejimso",
          "Egyh": "jeratiko ejimso",
          "Egyp": "jerógrifo ejimso",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "etijópiko",
          "Geok": "kehunsuri geórgijỹnũ",
          "Geor": "geórgijỹnũ",
          "Glag": "gragoritiko",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "gótiko",
          "Gran": "Gran",
          "Grek": "gregu",
          "Gujr": "guserate",
          "Guru": "gurmũki",
          "Hanb": "hỹnme",
          "Hang": "hỹngur",
          "Hani": "hỹn",
          "Hano": "hỹnũnũ",
          "Hans": "sĩpri-há",
          "Hant": "si-pẽ",
          "Hatr": "Hatr",
          "Hebr": "hemraiko",
          "Hira": "hiragỹnỹ",
          "Hluw": "Hluw",
          "Hmng": "pahav homãg",
          "Hmnp": "Hmnp",
          "Hrkt": "sirama-vẽnhrá japunẽj",
          "Hung": "hũgaru si",
          "Inds": "ĩnu",
          "Ital": "itariko si",
          "Jamo": "jỹmo",
          "Java": "javanẽj",
          "Jpan": "japunẽj",
          "Kali": "kaja-ri",
          "Kana": "katakỹnỹ",
          "Khar": "karositi",
          "Khmr": "kymẽr",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "kan-nỹna",
          "Kore": "korejỹnũ",
          "Kthi": "kanhi",
          "Lana": "rỹnỹ",
          "Laoo": "ra’o",
          "Latf": "ratĩnh fragtur",
          "Latg": "ratĩnh gajériko",
          "Latn": "ratĩnh",
          "Lepc": "rémsa",
          "Limb": "rĩmu",
          "Lina": "rĩnẽjar A",
          "Linb": "rĩnẽjar B",
          "Lisu": "risu",
          "Lyci": "risijo",
          "Lydi": "rinh-jo",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "mỹnajku",
          "Mani": "mỹnĩkejỹnũ",
          "Marc": "Marc",
          "Maya": "hijerógrifu maja",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "mẽrojitiku nĩgé-tỹ",
          "Mero": "mẽrojitiku",
          "Mlym": "marajara",
          "Modi": "Modi",
          "Mong": "mãgór",
          "Moon": "mũn",
          "Mroo": "Mroo",
          "Mtei": "mẽjtej mỹjéki",
          "Mult": "Mult",
          "Mymr": "mirmỹnẽj",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "nyko",
          "Nshu": "Nshu",
          "Ogam": "ogỹmiku",
          "Olck": "or siki",
          "Orkh": "orkihãn",
          "Orya": "orija",
          "Osge": "Osge",
          "Osma": "ojmỹnja",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "pérmĩku si",
          "Phag": "fagpa",
          "Phli": "pahir",
          "Phlp": "pahin",
          "Phlv": "pahiravi si",
          "Phnx": "fenĩso",
          "Plrd": "fonẽtiko porarne",
          "Prti": "priti",
          "Qaag": "Qaag",
          "Rjng": "rejỹg",
          "Rohg": "Rohg",
          "Roro": "rãgorãgo",
          "Runr": "runĩku",
          "Samr": "samỹritỹnũ",
          "Sara": "sarati",
          "Sarb": "Sarb",
          "Saur": "savurajtera",
          "Sgnw": "vẽnh-mu vẽnhrád",
          "Shaw": "savijỹnũ",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "sĩgarẽj",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "sũnanẽj",
          "Sylo": "syroti nỹgri",
          "Syrc": "sirijaku",
          "Syre": "sirijaku esitarageru",
          "Syrj": "sirijaku rãpur",
          "Syrn": "sirijaku rãjur",
          "Tagb": "tagmánva",
          "Takr": "Takr",
          "Tale": "taj-re",
          "Talu": "taj-re tãg",
          "Taml": "tỹmĩr",
          "Tang": "Tang",
          "Tavt": "tavuti",
          "Telu": "térugu",
          "Teng": "tẽgvar",
          "Tfng": "tifinỹg",
          "Tglg": "tagaru",
          "Thaa": "ta’anỹ",
          "Thai": "tajrỹnej",
          "Tibt": "timetỹnũ",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "ugaritiku",
          "Vaii": "vaj",
          "Visp": "vĩ-ve-há",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "pérsa si",
          "Xsux": "sumẽrijo-akanhỹnũ kafén ja",
          "Yezi": "Yezi",
          "Yiii": "yji",
          "Zanb": "Zanb",
          "Zinh": "ernanu",
          "Zmth": "vẽnhnĩkrén rá",
          "Zsye": "Emãji",
          "Zsym": "zsym",
          "Zxxx": "vẽnhrá-tũ",
          "Zyyy": "kãmũ",
          "Zzzz": "vẽnhrá ki kagtĩg"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "kgp"
})
}